import styled, { css } from 'styled-components';
import { DesignStyle } from './types';
import { customClassNames } from './utils';

export const withSiteTheme = (css: string) => `
    .${DesignStyle.SITE_THEME} & {${css}}
`;

const buttonStyles = css`
    background-color: var(--btn-bg-color);
    background-image: var(--btn-bg-image);
    background-position: var(--btn-bg-position);
    background-repeat: var(--btn-bg-repeat);
    background-size: var(--btn-bg-size);
    border-color: var(--btn-border-color);
    border-bottom-color: var(--btn-border-b-color);
    border-left-color: var(--btn-border-l-color);
    border-right-color: var(--btn-border-r-color);
    border-top-color: var(--btn-border-t-color);
    border-radius: var(--btn-border-radius);
    border-bottom-left-radius: var(--btn-border-bl-radius);
    border-bottom-right-radius: var(--btn-border-br-radius);
    border-top-left-radius: var(--btn-border-tl-radius);
    border-top-right-radius: var(--btn-border-tr-radius);
    border-width: var(--btn-border-width);
    border-bottom-width: var(--btn-border-b-width);
    border-left-width: var(--btn-border-l-width);
    border-right-width: var(--btn-border-r-width);
    border-top-width: var(--btn-border-t-width);
    direction: var(--btn-text-direction);
    text-align: var(--btn-text-align);

    color: var(--btn-text-color);
    font-family: var(--btn-text-font-family);
    font-size: var(--btn-text-font-size);
    font-weight: var(--btn-text-font-weight);
    text-decoration: var(--btn-text-decoration);

    &:hover {
        background: var(--btn-hover-bg);
        border-color: var(--btn-hover-border-color);
        border-bottom-color: var(--btn-hover-border-b-color);
        border-left-color: var(--btn-hover-border-l-color);
        border-right-color: var(--btn-hover-border-r-color);
        border-top-color: var(--btn-hover-border-t-color);
    }
`;

export const CalBookingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .booker-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
    }

    ${getBookerStyles()}
`;

function getBookerStyles() {
    return css`
        .${customClassNames.atomsWrapper} {
            height: 100%;
            width: 100%;
            text-align: initial;
        }

        .${customClassNames.bookerContainer} {
            --booker-meta-width: 280px;
            --booker-main-width: initial;
            --booker-timeslots-width: 280px;
            border-radius: 6px;
            width: 100% !important;
            height: 100% !important;

            > div[class*='grid-area:meta'] {
                position: static !important;
            }

            form {
                [data-testid='select-control'] {
                    > div {
                        height: var(--cal-spacing-8);
                        font-size: small;
                    }

                    div:has(> svg) {
                        height: auto;
                    }

                    // fix for dropdown chevron position
                    div:has(> div > svg) {
                        top: 50%;
                        position: relative;
                        translate: 0 -50%;
                    }

                    input {
                        height: auto;
                    }
                }
            }
        }

        .${customClassNames.eventMetaCustomClassNames.eventMetaTitle} {
            font-size: 18px !important;
        }

        &.${DesignStyle.SITE_THEME} {
            .${customClassNames.bookerContainer} {
                border-color: var(--color_1);
                background-color: var(--color_3);

                .react-tel-input,
                .flag-dropdown {
                    background-color: inherit !important;
                }

                [data-testid='select-control'] {
                    > div {
                        background-color: var(--color_3);
                    }
                }

                textarea,
                input {
                    background-color: var(--color_3) !important;
                    box-shadow: none !important;

                    &::placeholder {
                        color: var(--color_1);
                        opacity: 0.25;
                    }
                }

                [data-fob-field-name='guests'] {
                    input {
                        height: 100%;
                    }

                    div:has(input) {
                        background-color: var(--color_3);
                    }
                }
            }

            .${customClassNames.datePickerCustomClassNames
                    .datePickerDatesActive} {
                background-color: var(--color_1);
                color: var(--color_4);
            }

            .${customClassNames.availableTimeSlotsCustomClassNames
                    .availableTimeSlotsHeaderContainer} {
                background-color: transparent;
            }

            .${customClassNames.confirmStep.confirmButton},
                .${customClassNames.confirmStep.backButton} {
                ${buttonStyles}
            }

            [data-testid='add-guests'] {
                color: var(--color_2);

                &:hover {
                    background-color: transparent;
                    border: unset;
                }
            }

            .${customClassNames.availableTimeSlotsCustomClassNames
                    .availableTimes} {
                border-radius: var(--btn-border-radius);
                border-color: var(--color_1);

                &:not(:disabled):hover {
                    background-color: var(--color_4) !important;
                }
            }

            .${customClassNames.availableTimeSlotsCustomClassNames
                    .availableTimeSlotsTimeFormatToggle} {
                button[aria-checked='true'] {
                    background-color: var(--color_5);
                }
            }

            .${customClassNames.datePickerCustomClassNames.datePickerToggle} {
                color: var(--color_1);

                &:disabled {
                    opacity: 0.4;
                }
            }

            .${customClassNames.datePickerCustomClassNames.datePickerDays} {
                font-size: 0.7rem;
            }
        }
    `;
}

export const containerQuery = (widgetId: string) => `
    [id="${widgetId}"] {
        .${customClassNames.atomsWrapper} {
            container-type: inline-size;
            container-name: atoms-wrapper;
        }
            
        @container atoms-wrapper (max-width: 960px) {
            .${customClassNames.bookerContainer} {
                --booker-meta-width: 100%;
                --booker-main-width: 100%;
                --booker-timeslots-width: 100%;
                display: flex !important;
                flex-direction: column;

                > div {
                    border: unset;
                    height: auto;
                    width: 100%;
                }
            }
        }
    }
`;
